import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { GalleryComponent } from './gallery/gallery.component';
import { ContactUsComponent } from './contact/contactUs.component';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ServicesComponent } from './services/services.component';
import { ProductComponent } from './product/product.component';
import { BeautyProductComponent } from './beauty-product/beautyProduct.component';
import { WeightMachineComponent } from './weight-machine/weightMachine.component';
import { PsiComponent } from './psi/psi.component';
import { AtlPackage1Component } from './atl-package1/atlPackage1.component';
import { AtlPackage2Component } from './atl-package2/atlPackage2.component';
import { AtlPackage3Component } from './atl-package3/atlPackage3.component';
import { AtlPackage4Component } from './atl-package4/atlPackage4.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    GalleryComponent,
    ContactUsComponent,
    ServicesComponent,
    ProductComponent,
    BeautyProductComponent,
    WeightMachineComponent,
    PsiComponent,
    AtlPackage1Component,
    AtlPackage2Component,
    AtlPackage3Component,
    AtlPackage4Component
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/xampp/htdocs/Techbotz-master/src/app/app.module.ts